module.exports = __webpack_public_path__ + "static/media/banner.1647b34f.jpg";